import './App.css';

function App() {
  return (
    <main className="statement-page">
      <h1 className="statement" aria-label="Intelligence at your hands">
        <span className="statement-primary">Intelligence</span>
        <span className="statement-accent">at your</span>
        <span className="statement-primary statement-final">
          hands<span aria-hidden="true">.</span>
        </span>
      </h1>
    </main>
  );
}

export default App;
